const c = {
  "10px": "v-fs-10",
  "12px": "v-fs-12",
  "14px": "v-fs-14",
  "16px": "v-fs-16",
  "18px": "v-fs-18",
  "20px": "v-fs-20",
  "24px": "v-fs-24"
}, e = {
  400: "v-fw-400",
  500: "v-fw-500",
  600: "v-fw-600",
  700: "v-fw-700",
  800: "v-fw-800",
  regular: "v-fw-400",
  medium: "v-fw-500",
  semiBold: "v-fw-600",
  bold: "v-fw-700",
  extraBold: "v-fw-800"
}, r = {
  nextBlack: "v-fc-n-black",
  nextGreyscale900: "v-fc-n-g900",
  nextGreyscale800: "v-fc-n-g800",
  nextGreyscale700: "v-fc-n-g700",
  nextGreyscale600: "v-fc-n-g600",
  nextGreyscale500: "v-fc-n-g500",
  nextGreyscale400: "v-fc-n-g400",
  nextGreyscale300: "v-fc-n-g300",
  nextGreyscale200: "v-fc-n-g200",
  nextGreyscale100: "v-fc-n-g100",
  nextGreyscale50: "v-fc-n-g50",
  nextGreyscale25: "v-fc-n-g25",
  nextGreyscale0: "v-fc-n-g0",
  nextWhite: "v-fc-n-white",
  nextPrimaryActive: "v-fc-n-p-active",
  nextPrimaryHover: "v-fc-n-p-hover",
  nextPrimaryCore: "v-fc-n-p-core",
  nextPrimaryFocus: "v-fc-n-p-focus",
  nextPrimaryHighlight: "v-fc-n-p-highlight",
  nextPrimaryBackground: "v-fc-n-p-background",
  primaryActive: "v-fc-p-active",
  primaryHover: "v-fc-p-hover",
  primaryCore: "v-fc-p-core",
  primaryFocus: "v-fc-p-focus",
  primaryHighlight: "v-fc-p-highlight",
  primaryBackground: "v-fc-p-background",
  alertActive: "v-fc-alert-active",
  alertHover: "v-fc-alert-hover",
  alertCore: "v-fc-alert-core",
  alertFocus: "v-fc-alert-focus",
  alertHighlight: "v-fc-alert-highlight",
  alertBackground: "v-fc-alert-background",
  cautionText: "v-fc-caution-text",
  cautionActive: "v-fc-caution-active",
  cautionHover: "v-fc-caution-hover",
  cautionCore: "v-fc-caution-core",
  cautionFocus: "v-fc-caution-focus",
  cautionHighlight: "v-fc-caution-highlight",
  cautionBackground: "v-fc-caution-background",
  successActive: "v-fc-success-active",
  successHover: "v-fc-success-hover",
  successCore: "v-fc-success-core",
  successFocus: "v-fc-success-focus",
  successHighlight: "v-fc-success-highlight",
  successBackground: "v-fc-success-background",
  infoHover: "v-fc-info-hover",
  infoCore: "v-fc-info-core",
  infoFocus: "v-fc-info-focus",
  infoHighlight: "v-fc-info-highlight",
  infoBackground: "v-fc-info-background",
  gradient: "v-fc-gradient",
  nextGradient: "v-fc-n-gradient"
}, t = {
  left: "v-ta-l",
  center: "v-ta-c",
  right: "v-ta-r"
};
export {
  r as fontColorToClassName,
  c as fontSizeToClassName,
  e as fontWeightToClassName,
  t as textAlignToClassName
};
